module.exports = __webpack_public_path__ + "img/back buttons quantity.401cc72b.png";